import React from "react"
import { Button } from "shared/buttons"
import { redirectTo, ADMIN_NEW_ANSWER_OPTIONS_LIST_PATH } from "utils/routeHelpers"

const AddAnswerOptionsListButton = () => (
  <Button
    className="border border-light-300 text-focus"
    text="+ Add Answer Options List"
    onClick={() => redirectTo(ADMIN_NEW_ANSWER_OPTIONS_LIST_PATH)}
  />
)

export default AddAnswerOptionsListButton
